import moment from "moment";
import { makeStamp, validDate, validTime } from "./timestamp";

export const shiftFilter = (shifts, date) => {
  return shifts.filter((shift) =>
    validTime(date, shift.startTime, shift.endTime)
  );
};

export const selectedEmployee = (employees, name) => {
  return employees.find(
    (employee) =>
      employee.Firstname + " " + employee.Lastname === name ||
      (employee.hasOwnProperty("Alias") && employee.Alias === name)
  );
};

export const selectedShift = (shifts, id) => {
  return shifts?.find((item) => item.id === id);
};

export const selectedDepartment = (departments, name) => {
  return departments.find((item) => item.department === name);
};

export const availableShifts = (shifts, date) => {
  let _shifts = [];
  if (validDate(date)) {
    const now = moment();
    shifts.map((shift) => {
      const { startTime, endTime } = makeStamp(
        date,
        shift.startTime,
        shift.endTime
      );

      if (now.isBefore(moment(startTime))) _shifts.push(shift);
    });
  }
  return _shifts;
};
